import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'dialog',
    template: '',
    standalone: true,
})
export class BaseDialogComponent implements AfterViewInit {
    @ViewChild('focusInput')
    focusInput: ElementRef;

    constructor(public dialogRef: MatDialogRef<any>) {}

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.focusInput instanceof ElementRef) {
                this.focusInput.nativeElement.focus();
            }
        }, 450);
    }

    dismiss(val: any = false): void {
        this.dialogRef.close(val);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
